/* eslint-disable no-unused-vars */
import axios from 'axios';
import moment from 'moment';
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/permissions`;

const state = {
    permissions: [],
    permissionsCount: null
};

const getters = {
    allPermissions: state => state.permissions,
    totalPermissionsCount: state => state.permissionsCount
};

const actions = {
    async fetchPermissions({ commit }, payload) {
        try {
            let page = payload.page || null
            let limit = payload.itemsPerPage 
            if(limit == -1) {
                limit = 1000
            }
            const url1 = url + "?page=" + page + "&limit=" + limit
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(url1, {
                headers: { 'x-drmms-token': authToken }
            });
            // let permissions = [];
            // permissions = response.data.rows.map((permission) => ({
            //     ...permission,
            //     date: moment(permission.createdAt).format('LLL'),
            // }))
            let permissions = {
                count: response.data.count,
                rows: response.data.rows.map((permission) => ({
                    ...permission,
                    date: moment(permission.createdAt).format('LLL'),
                }))

            }
            commit('setPermissions', permissions);
        } catch (err) {
            console.log(err);
        }
    },
    async createPermission({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.post(url, body, {
                headers: { 'x-drmms-token': authToken }
            });
            let newPermission = Object.assign(response.data, { date: moment(response.data.createdAt).format('LLL') });
            commit('newPermission', newPermission);
            return response.data;
        } catch (err) {
            console.log(err);
        }
    },




    async updatePermission({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios({
                method: 'put',
                url: `${url}/${body.id}`,
                headers: { 'x-drmms-token': authToken },
                data: {
                    name: body.name,
                    description: body.description
                }
            });
            commit('updatePermission', body);
            return true;
        } catch (err) {
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 400) return { error: true, status: 500, message: 'Internal Server Error' };
            }
            console.log(err);
        }
    },




    async deletePermission({ commit }, id) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios({
                method: "delete",
                url,
                headers: { "x-drmms-token": authToken },
                data: { id },
            });
            commit('removePermission', id);
            return response;
        } catch (err) {
            console.log(err);
        }
    }
};

const mutations = {
    setPermissions: (state, permissions) => {
        state.permissions = permissions.rows;
        state.permissionsCount = permissions.count

    }, 
    newPermission: (state, permission) => state.permissions.push(permission),
    removePermission: (state, id) => {
        for (let i = 0; i < id.length; i++) {
            state.permissions = state.permissions.filter(permission => permission.id !== id[i])
        }

    },
    updatePermission: (state, updPermission) => {
        const index = state.permissions.findIndex(permission => permission.id === updPermission.id);
        if (index !== -1) {
            state.permissions.splice(index, 1, updPermission);
        }
    }

};

export default {
    state,
    getters,
    actions,
    mutations,
}